const {
  VITE_RUN_ENV, VITE_PUBLIC_URL, PROD, DEV,
} = import.meta.env;

export type EnvironmentType = {
  VITE_RUN_ENV?: string;
  VITE_PUBLIC_URL?: string;
  PROD?: boolean;
  DEV?: boolean;
};

export default {
  VITE_RUN_ENV,
  VITE_PUBLIC_URL,
  PROD,
  DEV,
};
